import { isMockMode, post, simulateDelay } from "../api";

export const getSubsByProduct = (data) => {
	if (isMockMode()) {
		const testData = [
			{
				subscribedSubs: [
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 10,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-08-30T04:37:29.8751807",
						expirationDateUtc: "2023-10-30T13:00:00",
						isEnabled: true,
					},
				],
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				subscribedSubs: [
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-07-26T05:26:55.6016817",
						expirationDateUtc: "2050-08-31T00:00:00",
						isEnabled: true,
					},
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-08-29T03:47:15.2140491",
						expirationDateUtc: "2050-08-30T14:00:00",
						isEnabled: true,
					},
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-08-03T03:13:22.0158684",
						expirationDateUtc: "2050-08-30T14:00:00",
						isEnabled: true,
					},
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-08-29T03:46:52.8730089",
						expirationDateUtc: "2050-08-30T14:00:00",
						isEnabled: true,
					},
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-08-29T03:47:42.5423402",
						expirationDateUtc: "2050-08-30T14:00:00",
						isEnabled: true,
					},
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-08-29T03:48:06.3057777",
						expirationDateUtc: "2050-08-30T14:00:00",
						isEnabled: true,
					},
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1000,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-09-14T04:39:29.5223496",
						expirationDateUtc: "2049-12-29T00:00:00",
						isEnabled: true,
					},
				],
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				subscribedSubs: [
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 1,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-11-10T22:58:12.893585",
						expirationDateUtc: "2023-10-30T13:00:00",
						isEnabled: true,
					},
				],
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				subscribedSubs: [
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 10,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-12-05T03:42:18.4662987",
						expirationDateUtc: "2022-12-04T00:00:00",
						isEnabled: true,
					},
				],
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
			{
				subscribedSubs: [
					{
						createdBy: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							email: "test.mctestie@mgaol.abc",
							firstName: "Test",
							lastName: "McTestie",
						},
						usedLicenceCount: 0,
						numberOfLicences: 10,
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						issuerOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						subscriberOrg: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						offering: {
							id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
							name: "Test Name",
						},
						createdDateUtc: "2022-12-05T04:00:18.0637796",
						expirationDateUtc: "2023-12-05T13:00:00",
						isEnabled: true,
					},
				],
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
			},
		];

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/getSubsByProduct`, data);
};
